import React from 'react';
import styled from 'styled-components';

/**
 *
 * A wave loader to be displayed when the list loads
 * @public
 */

const ChartLoader = (props) => {
  return (
    <Loader loaderColor={props?.loaderColor}>
      <div className="preloader">
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
    </Loader>
  );
};

export default ChartLoader;

const Loader = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  .preloader {
    position: relative;
    width: 25px;
    height: 100%;
    transform: translate(-50%, -50%);
  }
  .preloader span {
    position: absolute;
    display: block;
    bottom: 0;
    width: 6px;
    height: 3px;
    border-radius: 5px;
    background: ${({ loaderColor }) =>
      loaderColor || 'rgba(226, 226, 241, 0.7)'} !important;
    -webkit-animation: preloader 2s infinite ease-in-out;
    animation: preloader 2s infinite ease-in-out;
  }
  .preloader span:nth-child(2) {
    left: 8px;
    -webkit-animation-delay: 200ms;
    animation-delay: 200ms;
  }
  .preloader span:nth-child(3) {
    left: 16px;
    -webkit-animation-delay: 400ms;
    animation-delay: 400ms;
  }
  .preloader span:nth-child(4) {
    left: 24px;
    -webkit-animation-delay: 600ms;
    animation-delay: 600ms;
  }
  .preloader span:nth-child(5) {
    left: 32px;
    -webkit-animation-delay: 800ms;
    animation-delay: 800ms;
  }

  @-webkit-keyframes preloader {
    0% {
      height: 5px;
      -webkit-transform: translateY(0);
      transform: translateY(0);
      background: ${({ loaderColor }) =>
        loaderColor || 'rgba(226, 226, 241, 0.7)'} !important;
    }
    25% {
      height: 20px;
      -webkit-transform: translateY(15px);
      transform: translateY(15px);
      background: ${({ loaderColor }) =>
        loaderColor || 'rgba(226, 226, 241, 0.7)'} !important;
    }
    50%,
    100% {
      height: 5px;
      -webkit-transform: translateY(0);
      transform: translateY(0);
      background: ${({ loaderColor }) =>
        loaderColor || 'rgba(226, 226, 241, 0.7)'} !important;
    }
  }

  @keyframes preloader {
    0% {
      height: 5px;
      -webkit-transform: translateY(0);
      transform: translateY(0);
      background: ${({ loaderColor }) =>
        loaderColor || 'rgba(226, 226, 241, 0.7)'} !important;
    }
    25% {
      height: 20px;
      -webkit-transform: translateY(10px);
      transform: translateY(10px);
      background: ${({ loaderColor }) =>
        loaderColor || 'rgba(226, 226, 241, 0.7)'} !important;
    }
    50%,
    100% {
      height: 5px;
      -webkit-transform: translateY(0);
      transform: translateY(0);
      background: ${({ loaderColor }) =>
        loaderColor || 'rgba(226, 226, 241, 0.7)'} !important;
    }
  }
`;
